'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var clsx_m = require('../node_modules/clsx/dist/clsx.m.js');
var styles = require('@material-ui/styles');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["width", "variant"];
/* From
https://codepen.io/danielmorosan/pen/XmYBVx
Huge thanks to @tobiasahlin at http://tobiasahlin.com/spinkit/ */

var useStyles = styles.makeStyles(theme => ({
  ball: {
    backgroundColor: props => props.variant === 'primary' ? theme.palette.primary.main : props.variant === 'secondary' ? theme.palette.secondary.main : theme.palette.grey[500]
  },
  bounce1: {},
  bounce2: {},
  bounce3: {},
  spinner: {
    width: props => props.width,
    textAlign: 'center',
    height: props => props.width * 0.8,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '& div': {
      width: props => props.width * 0.25,
      height: props => props.width * 0.25,
      margin: 'auto 0',
      borderRadius: '100%',
      display: 'inline-block',
      animation: '$sk-bouncedelay 1.4s infinite ease-in-out both',
      '&$bounce1': {
        animationDelay: '-0.32s'
      },
      '&$bounce2': {
        animationDelay: '-0.16s'
      }
    }
  },
  '@keyframes sk-bouncedelay': {
    '0%, 80%, 100%': {
      transform: 'scale(0)'
    },
    '40%': {
      transform: 'scale(1.0)'
    }
  }
}));
/**
 * Loading component to display on non full page content
 */

var MiniLoader = _ref => {
  var {
    width = 40,
    variant = 'default'
  } = _ref,
      props = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var classes = useStyles({
    variant,
    width
  });
  return /*#__PURE__*/React__default['default'].createElement("div", _rollupPluginBabelHelpers['extends']({
    className: classes.spinner
  }, props), /*#__PURE__*/React__default['default'].createElement("div", {
    className: clsx_m(classes.ball, classes.bounce1)
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: clsx_m(classes.ball, classes.bounce2)
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: clsx_m(classes.ball, classes.bounce3)
  }));
};
MiniLoader.propTypes = {
  /** The width of the container. */
  width: index.number,

  /** Color variant of the loader. */
  variant: index.oneOf(['default', 'primary', 'secondary'])
};

exports.MiniLoader = MiniLoader;
exports.default = MiniLoader;
